import React, { useState, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';

import '../Assets/Css/home.css';
import { Container, Row, Col, Button, } from 'react-bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { FaAnglesRight } from "react-icons/fa6";
import farmer1 from '../Assets/Image/farmer1.jpg';
import farmer2 from '../Assets/Image/farmer2.avif';
import farmer3 from '../Assets/Image/farmer3.jpg';
import farmer4 from '../Assets/Image/farmer4.png';
import leftaboutsection from '../Assets/Image/Agriculture3.png'
import rightaboutsection from '../Assets/Image/agribannerimage11.png'

import service1 from '../Assets/Image/Agribannerimg1.png';
import service2 from '../Assets/Image/franchisismodel.png';
import service3 from '../Assets/Image/serviceconsulting.png'
import service4 from '../Assets/Image/RandDCenter.png';
import service5 from '../Assets/Image/Trainingandseminars.png'

import aboutsection from '../Assets/Image/betogethercta.jpg'
import totalAgrisol from '../Assets/Image/gallery2.jpg'
 import samratseed from '../Assets/Image/samratseeds.jfif' 
import wheatImg from '../Assets/Image/wheatseed.png';
import soybeanImg from '../Assets/Image/soyabeanseed.png';
import paddyImg from '../Assets/Image/padyseed.png';
import vegetablesImg from '../Assets/Image/vegetableseed.png';
import organicImg from '../Assets/Image/fertilizersandpesticides.png';
import irrigationImg from '../Assets/Image/Agrieuipment.png';

import { FaSeedling, FaUsers } from 'react-icons/fa';
import { MdKeyboardDoubleArrowRight } from "react-icons/md";



export default function HomePage() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: false });
    AOS.refresh();
  }, []);

  const navigate = useNavigate();

  const service = [
    {
      title: "Seed & Fertilizer Supply",
      description: "Delivery of certified and high-quality seeds and fertilizers.",
      tag: "Quality Inputs",
      image: service1,
    },
    {
      title: "Franchise Model",
      description: "Providing agricultural franchise opportunities to aspiring entrepreneurs.",
      tag: "Business Opportunity",
      image: service2,
    },
    {
      title: "Agri Consulting",
      description: "Expert guidance on crop selection, pest control, irrigation planning, and soil testing.",
      tag: "Expert Guidance",
      image: service3,
    },
    {
      title: "R&D Center",
      description: "Focused on seed improvement and new agricultural technologies.",
      tag: "Innovation Hub",
      image: service4,
    },
    {
      title: "Training & Seminars",
      description: "Workshops and educational programs for farmers and dealers.",
      tag: "Skill Development",
      image: service5,
    },
  ];

  const productSlides = [
    {
      title: "Wheat Seeds",
      image: wheatImg,
      description: "Premium wheat seeds designed for high yield and disease resistance."
    },
    {
      title: "Soybean Seeds",
      image: soybeanImg,
      description: "Genetically advanced soybean seeds for sustainable farming."
    },
    {
      title: "Paddy Seeds",
      image: paddyImg,
      description: "High-yield paddy seeds optimized for Indian climates."
    },
    {
      title: "Vegetable Seeds",
      image: vegetablesImg,
      description: "Diverse vegetable seed varieties for commercial and home farming."
    },
    {
      title: "Organic Fertilizers & Pesticides",
      image: organicImg,
      description: "Chemical-free organic solutions to enrich your soil and protect crops."
    },
    {
      title: "Agri Equipment & Irrigation Kits",
      image: irrigationImg,
      description: "Modern equipment and micro-irrigation kits to boost productivity."
    }
  ];

  const [activeIndex, setActiveIndex] = useState(0);






  const testimonials = [
    {

      role: "Farmer – Maharashtra",
      message:
        "Hiranand Agri Solutions helped me switch to high-yield organic farming. Their team guided me through every step of the way.",
    },
    {

      role: "Agri Dealer – Uttar Pradesh",
      message:
        "From soil testing to product training, their support has helped me grow my agri-input business more confidently.",
    },
    {

      role: "Franchise Owner – Karnataka",
      message:
        "Becoming a Hiranand franchisee has been life-changing. Their branding, logistics, and advisory are world-class.",
    },
    {

      role: "Organic Vegetable Farmer – Madhya Pradesh",
      message:
        "Thanks to their quality seeds and timely training, my vegetable yield has doubled with better prices in local markets.",
    },
    {

      role: "Student, Agri Workshop – Rajasthan",
      message:
        "I attended their training seminar, and it was insightful. Now I feel ready to launch my own sustainable farm.",
    },
    {

      role: "Agri Consultant – Punjab",
      message:
        "The expert insights provided by Hiranand Agri Solutions helped our team implement smarter irrigation and crop planning strategies. Truly professional and impactful.",
    }
  ];





  return (
    <>
      <div>

        <Helmet>
          <title>Hiranand Agri Solutions Pvt. Ltd. | Empowering Rural Growth through Agri-Tech</title>
          <meta
            name="description"
            content="Hiranand Agri Solutions Pvt. Ltd. empowers over 100K+ farmers with high-quality seeds, fertilizers, agri-equipment, expert consulting, and franchise opportunities."
          />
          <meta
            name="keywords"
            content="agriculture, agri-tech, organic farming, seed supply, fertilizers, agri franchise, agri consulting, sustainable farming, R&D agriculture, farmer training"
          />
          <meta name="author" content="Hiranand Agri Solutions Pvt. Ltd." />

          {/* Open Graph / Facebook */}
          <meta property="og:title" content="Hiranand Agri Solutions Pvt. Ltd. | Prosperity for Farmers & Innovation in Agriculture" />
          <meta
            property="og:description"
            content="Join Hiranand Agri Solutions Pvt. Ltd. in transforming Indian agriculture. Explore our products, services, and franchise model to drive rural growth."
          />
          <meta property="og:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" /> {/* Update with actual banner/logo URL */}
          <meta property="og:url" content="https://hiranandagrisolutions.com/" />
          <meta property="og:type" content="website" />

          {/* Twitter Card */}
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Hiranand Agri Solutions Pvt. Ltd." />
          <meta
            name="twitter:description"
            content="Smart agri-tech solutions, premium inputs, consulting, and training to empower Indian farmers."
          />
          <meta name="twitter:image" content="https://hiranandagrisolutions.com/assets/images/logo.png" />

          {/* Canonical URL */}
          <link rel="canonical" href="https://hiranandagrisolutions.com/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>



        <div className=" banner1-section d-flex align-items-center justify-content-center">
          <div className="container banner1-overlay text-center">
            <h2 className="banner1-title" data-aos="zoom-in" data-aos-delay="100">
              Welcome to
              <span style={{ letterSpacing: '4px' }}> Hiranand </span>
              Agri Solutions Pvt. Ltd.
            </h2>
            <p className=" banner1-description"  data-aos="zoom-in" data-aos-delay="100">

              Empowering rural growth through smart agri-tech solutions.
              Driving prosperity through technology, tradition, and trust.
            </p>
          </div>
        </div>








        <section className="about-section py-4" style={{ marginTop: '40px' }}>
          <Container>
            <Row className="text-center section-heading" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  Dedication to Innovation and  <br />
                  <span style={{ color: '#16343E' }}> Service in Agriculture</span>
                  <span className="title-decoration">  </span>
                </h3>
              </Col>
            </Row>

            <Row>
              <Col xs={12} md={3} className="mb-4 mb-md-0" data-aos="zoom-in" data-aos-delay="200">
                <img
                  src={leftaboutsection}
                  alt="Agriculture"
                  className="img-fluid rounded"
                />
              </Col>

              <Col xs={12} md={6} className="aboutmid mb-4" data-aos="fade-up" data-aos-delay="300">
                <div className="about-text-wrapper text-center text-md-start">
                  <h5 className="mb-3 fw-semibold">
                    Hiranand Agri Solutions Pvt. Ltd. is a committed company that provides a blend of scientific,
                    traditional, and modern technologies to farmers.
                  </h5>
                  <ul className="about-goals list-unstyled mb-0">
                    <li> Increase agricultural production</li>
                    <li> Enhance farmers' income</li>
                    <li>Promote sustainable development</li>
                  </ul>
                </div>
              </Col>



              <Col xs={12} md={3} className="rightimage" data-aos="zoom-in" data-aos-delay="500">
                <img
                  src={rightaboutsection}
                  alt="Agriculture"
                  className="img-fluid rounded mb-3"
                />
              </Col>
            </Row>
          </Container>
        </section>

        <section className="our-goal-highlight py-4">
          <div className="goal-overlay"></div>
          <div className="container  
   d-flex 
  flex-column 
  flex-md-row
   align-items-center 
  justify-content-between"
            style={{ padding: '40px' }}
          >
            {/* Goal text */}
            <div className="text-start" data-aos="zoom-in" data-aos-delay="300">
              <h3 className="mb-0 fw-bold text-white" >Our Goal</h3>
              <h5 className='text-white'> <strong>Prosperity for Farmers<br />& Innovation in Agriculture</strong></h5>
            </div>

            {/* Avatars and count */}
            <div className="d-flex align-items-center mb-3" data-aos="zoom-in" data-aos-delay="100">
              <div className="avatars d-flex me-3">
                <img src={farmer1} alt="Farmer 1" className="rounded-circle avatar-img" />
                <img src={farmer2} alt="Farmer 2" className="rounded-circle avatar-img" />
                <img src={farmer3} alt="Farmer 3" className="rounded-circle avatar-img" />
                <img src={farmer4} alt="Farmer 3" className="rounded-circle avatar-img" />
              </div>
              <div className="text-start">
                <h4 className="mb-0 text-white fw-bold">Empowering</h4>
                <h5 className='text-white'><strong>100K+ Farmers</strong></h5>
              </div>
            </div>



            {/* Circular keyword icon */}
            <div className="circular-goal text-center mx-3 my-3 my-md-0" data-aos="zoom-in" data-aos-delay="500">
              <div className="circle-text">Prosperity Innovation</div>
            </div>

          </div>
        </section>


        <section className="services-section py-5  ">
          <div className="" >
            <Row className="text-center section-heading mb-5 pt-3" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  Our
                  <span style={{ color: '#16343E' }}> Services</span>
                  <span className="title-decoration">  </span>
                </h3>
              </Col>
            </Row>
            <div className="row g-4 mb-4 justify-content-center">
              {service.map((service, idx) => (
                <div className="col-12 col-md-4 col-lg-2_5" key={idx} data-aos="zoom-in" data-aos-delay="100">
                  <div className="service-card h-100">
                    <img src={service.image} alt={service.title} className="img-fluid rounded-top service-img" />
                    <div className="p-3">
                      <span className="service-tag">{service.tag}</span>
                      <h5 className="mt-2 mb-2 fw-semibold">{service.title}</h5>
                      <p className="mb-0 ">{service.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
       
        <section className="py-5 agri-ventures-section" style={{ backgroundColor: 'rgba(240, 221, 181, 1)' }}>
          <Container>
             <Row className="text-center section-heading" data-aos="fade-down" data-aos-delay="100">
              <Col>
                <h3 className="fw-bold section-title">
                  Our
                  <span style={{ color: '#16343E' }}> Agri Ventures</span>
                  <span className="title-decoration">  </span>
                </h3>
              </Col>
            </Row>
          
            <p className="text-center mb-5" data-aos="fade-up">
              Delivering agricultural solutions through trusted platforms — both offline and online — to empower every farmer.
            </p>

            {/* Samrat Seeds Block */}
            <Row className="align-items-center mb-5 flex-column-reverse justify-content-center flex-md-row" data-aos="fade-up">
              <Col md={5}>
                <div className="venture-content p-3">
                  <h5 className="fw-bold d-flex align-items-center">
                    <FaSeedling className="me-2 text-success" /> Samrat Seeds
                  </h5>
                  <p className="text-muted">
                    Providing high-quality seeds since 2002, Samrat Seeds has become a trusted brand recognized for innovation, consistency, and farmer-first practices.
                  </p>
                  

                  <Button
  className='btnsmarat'
  as="a"
  href="https://samratseeds.in/"
  target="_blank"
  rel="noopener noreferrer"
>
  Visit Website <MdKeyboardDoubleArrowRight />
</Button>

                 
                </div>
              </Col>
              <Col md={5}>
                <img
                  src ={samratseed} 
                  alt="Samrat Seeds"
                  className="img-fluid rounded shadow-sm"
                  style={{height:'250px'}}
                />
              </Col>
            </Row>

            {/* Total Agri Solutions Block */}
            <Row className="align-items-center justify-content-center flex-column flex-md-row" data-aos="fade-up">
              <Col md={5}>
                <img
                 src ={totalAgrisol}
                  // src="/assets/image/totalagrisolution.jfif" // Replace with your actual image path
                  alt="Total Agri Solutions"
                  className="img-fluid rounded shadow-sm"
                />
              </Col>
              <Col md={5}>
                <div className="venture-content p-3">
                  <h5 className="fw-bold d-flex align-items-center">
                    <FaUsers className="me-2 text-primary" /> Total Agri Solutions
                  </h5>
                  <p className="text-muted">
                   A farmer-focused initiative providing complete agricultural guidance — from crop planning and soil health to pest control, fertilizers, and market insights. We empower farmers with practical support, expert knowledge, and region-specific solutions for sustainable growth.
                  </p>
                  <Button
  className='btnsmarat'
  as="a"
  href="https://kutumb.app/total-agri-solutions?ref=HWSOQ&screen=star_share"
  target="_blank"
  rel="noopener noreferrer"
>
  View Total agri solutions <MdKeyboardDoubleArrowRight />
</Button>
                 
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="product-slider-section py-5 ">
          <div className="container text-center p-3">
            <h3 className="fw-bold section-title mb-5" data-aos="fade-down" data-aos-delay="100">
              Our <span style={{ color: '#16343E' }}>Products  </span>
              <span className="title-decoration">  </span>
            </h3>

            <Swiper
              modules={[Autoplay]}
              spaceBetween={30}
              slidesPerView={3}
              centeredSlides
              loop
              autoplay={{ delay: 2500, disableOnInteraction: false }}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              breakpoints={{
                320: { slidesPerView: 1 },
                768: { slidesPerView: 2 },
                992: { slidesPerView: 3 },
              }}
              data-aos="zoom-in" data-aos-delay="100"
            >
              {productSlides.map((item, idx) => (
                <SwiperSlide key={idx}>
                  <div className={`product-slide-card ${activeIndex === idx ? 'active' : ''}`}>
                    <img src={item.image} alt={item.title} className="img-fluid rounded" />
                    <h6 className="mt-3">{item.title}</h6>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="mt-4 px-3">
              <p className="text-muted description-box">{productSlides[activeIndex].description}</p>
            </div>
          </div>
        </section>

        {/* <section className="impact-section py-5 text-white" style={{ backgroundColor: '#16343E' }}>
          <Container>
            <Row className="text-center mb-4" data-aos="fade-up">
              <Col>
                <h3 className="fw-bold mb-4" data-aos="fade-down" data-aos-delay="100">
                  Featured <span style={{ color: '#2e7d32' }}>Impact

                  </span>
                </h3>

                <p className="text-light">We’re proud of the milestones we’ve achieved with farmers across India.</p>
              </Col>
            </Row>

            

            <Row className="text-center g-4 align-items-stretch">
  <Col xs={6} md={3} data-aos="fade-up" data-aos-delay="100">
    <div className="impact-box h-100 d-flex flex-column justify-content-center">
      <h2 className="fw-bold">100K+</h2>
      <p className='text-white'>Farmers Empowered</p>
    </div>
  </Col>
  <Col xs={6} md={3} data-aos="fade-up" data-aos-delay="200">
    <div className="impact-box h-100 d-flex flex-column justify-content-center">
      <h2 className="fw-bold">500+</h2>
      <p className='text-white'>Villages Covered</p>
    </div>
  </Col>
  <Col xs={6} md={3} data-aos="fade-up" data-aos-delay="300">
    <div className="impact-box h-100 d-flex flex-column justify-content-center">
      <h2 className="fw-bold">50+</h2>
      <p className='text-white'>Agri Products Offered</p>
    </div>
  </Col>
  <Col xs={6} md={3} data-aos="fade-up" data-aos-delay="400">
    <div className="impact-box h-100 d-flex flex-column justify-content-center">
      <h2 className="fw-bold">100+</h2>
      <p className='text-white'>Training Sessions Conducted</p>
    </div>
  </Col>
</Row>

          </Container>
        </section> */}



        <section className="testimonial-carousel-section my-5">
          <div className="container py-3 ">
            <Row className="align-items-center justify-content-center flex-md-row m-0">
              <h3 className="fw-bold text-center section-title" data-aos="fade-down" data-aos-delay="100">
                Voices of <span style={{ color: '#16343E' }}>Trust & Transformation</span>
                <span className="title-decoration mb-2"></span>
              </h3>
              <p className="text-muted text-center" style={{ maxWidth: 700 }} data-aos="fade-down" data-aos-delay="100">
                Hear how Hiranand Agri Solutions pvt.ltd is empowering farmers and entrepreneurs across India.
              </p>
              <Col xs={12} md={8} className="text-center order-1 order-md-2" data-aos="zoom-in" data-aos-delay="200">

                <Swiper
                  modules={[Autoplay, Pagination]}
                  autoplay={{ delay: 4000 }}
                  pagination={{ clickable: true }}
                  loop
                  spaceBetween={30}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    768: { slidesPerView: 1 },
                    992: { slidesPerView: 1 },
                  }}
                >
                  {testimonials.map((testimonial, idx) => (
                    <SwiperSlide key={idx}>
                      <div className="testimonial-agri-card">
                        {/* <div className="quote-agri-icon">❝</div> */}
                        <p className="testimonial-agri-text">{testimonial.message}
                          
                        </p>
                         
                        
                        <div className="agri-client-info">
                          <img
                            src={require('../Assets/Image/farmer1.jpg')}
                            alt={testimonial.name}
                            className="agri-avatar"
                          />
                          <div>
                            <div className="agri-name">{testimonial.name}</div>
                            <small className="text-muted">{testimonial.role}</small>
                          </div>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>





              </Col>
            </Row>
          </div>
        </section>
      </div>
    </>
  );
}
